import { AppStoreButton, ButtonsContainer, GooglePlayButton } from "react-mobile-app-button";



export const AppStoreButtons = () => {

  const APKUrl = "https://play.google.com/store/apps/details?id=com.karmantrener.english_trainer";
  const IOSUrl = "https://apps.apple.com/app/english-trainer/id6825000182";

  // The package's "light" theme has no background (only a transparent box), so
  // the black badge is used in both site themes; see .store-badge in custom.scss.
  return (
    <ButtonsContainer>
      <GooglePlayButton
        height={55}
        url={APKUrl}
        theme="dark"
        className="store-badge"
      />

      <AppStoreButton
        height={55}
        url={IOSUrl}
        theme="dark"
        className="store-badge"
      />

    </ButtonsContainer>
  );

};
